import React from 'react';
import { Route } from 'react-router-dom';
import { Homepage } from '../pages';
import { ROUTES } from './routes';

// Lazy load the pages
const Regulation = React.lazy(() => import('../pages/Regulation').then((module) => ({ default: module.Regulation })));

export const RegulationRoutes = () => {
  return (
    <>
      <Route exact path={ROUTES.REGULATIONS_OVERVIEW.path}>
        <Homepage />
      </Route>
      <Route exact path={ROUTES.REGULATION_DETAIL.path}>
        <Regulation />
      </Route>
    </>
  );
};
